import '../styles/components/header.css'
import { store } from '../store.js'
import { getCurrentPath } from '../router.js'
import { getSession, onAuthChange } from '../lib/supabase.js'

const NAV_LINKS = [
  { href: '#/', label: 'Home' },
  { href: '#/shop', label: 'Shop' },
  { href: '#/contact', label: 'Contact' },
]

export function renderHeader(outlet) {
  outlet.innerHTML = `
    <header class="site-header">
      <div class="container header-inner">
        <a href="#/" class="header-logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="28" height="28" aria-hidden="true">
            <path d="M 96 391 C 71 -22, 443 -22, 443 377 C 443 433, 387 455, 352 399 C 367 409, 393 397, 393 377 C 393 28, 121 28, 96 391 Z" fill="currentColor"/>
            <circle cx="256" cy="252" r="28" fill="currentColor"/>
          </svg>
          Airplaten
        </a>

        <nav class="header-nav" id="main-nav">
          ${NAV_LINKS.map(l => `<a href="${l.href}" class="nav-link" data-href="${l.href}">${l.label}</a>`).join('')}
        </nav>

        <div class="header-actions">
          <button class="cart-btn" id="cart-btn" aria-label="Open cart">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
            </svg>
            <span class="cart-count" id="cart-count">0</span>
          </button>

          <button class="menu-toggle" id="menu-toggle" aria-label="Toggle menu">
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
    </header>
  `

  // Cart count subscription
  store.subscribe('cart', (cart) => {
    const count = cart.reduce((s, i) => s + i.quantity, 0)
    const countEl = document.getElementById('cart-count')
    if (!countEl) return
    countEl.textContent = count
    countEl.classList.toggle('visible', count > 0)
  })

  // Cart button
  document.getElementById('cart-btn')?.addEventListener('click', () => store.openCart())

  // Mobile menu toggle
  const menuToggle = document.getElementById('menu-toggle')
  const nav = document.getElementById('main-nav')
  menuToggle?.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('open')
    menuToggle.classList.toggle('open', isOpen)
    menuToggle.setAttribute('aria-expanded', String(isOpen))
  })

  // Active nav link
  updateActiveLink()
  window.addEventListener('hashchange', updateActiveLink)

  // Admin link: show/hide based on auth state
  async function syncAdminLink(session) {
    const nav = document.getElementById('main-nav')
    if (!nav) return
    const existing = nav.querySelector('.nav-link-admin')
    if (session && !existing) {
      const link = document.createElement('a')
      link.href = '#/admin'
      link.className = 'nav-link nav-link-admin'
      link.dataset.href = '#/admin'
      link.textContent = 'Admin'
      nav.appendChild(link)
    } else if (!session && existing) {
      existing.remove()
    }
    updateActiveLink()
  }

  getSession().then(syncAdminLink)
  onAuthChange(syncAdminLink)
}

function updateActiveLink() {
  const current = window.location.hash || '#/'
  document.querySelectorAll('.nav-link').forEach(link => {
    const href = link.dataset.href
    const isActive = href === current || (href !== '#/' && current.startsWith(href))
    link.classList.toggle('active', isActive)
  })
}
